import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/index/ib2.webp")